const facilityOptions = [
  "Wi-Fi",
  "Air Conditioning",
  "Television",
  "In-room Safe",
  "Minibar",
  "Coffee/Tea Maker",
  "Iron/Ironing Board",
  "Hairdryer",
  "Desk/Workspace",
  "Room Service",
  "Laundry Service",
  "Telephone",
  "Balcony/Terrace",
  "Private Bathroom",
  "Shower",
  "Bathtub",
  "Bathrobe",
  "Slippers",
  "Complimentary Toiletries",
  "Soundproof Rooms",
  "Heating",
  "Wardrobe/Closet",
  "Sofa",
  "Kitchenette",
  "Microwave",
  "Refrigerator",
  "Electric Kettle",
  "Blackout Curtains",
  "Safe",
  "Fitness Center Access",
];

const roomViewOptions = [
  "Ocean View",
  "Mountain View",
  "Garden View",
  "City View",
  "River View",
  "Lake View",
  "No View",
  "Forest View",
  "Bay View",
  "Park View",
];

const roomTypeOptions = [
  "Single",
  "Double",
  "Triple",
  "Twin",
  "Double/Twin",
  "Quad",
  "Family",
  "Studio",
  "Apartment",
  "Dorm",
  "Villa",
  "Vacation Home",
  "Bungalow",
  "Tent",
];

const beddingOptions = [
  "King Bed",
  "Queen Bed",
  "Single Bed",
  "Sofa Bed",
  "Bunk Bed",
  "1 King Bed and 1 Single Bed",
  "1 King Bed and 2 Single Beds",
  "1 Queen Bed and 1 Single Bed",
  "1 Queen Bed and 2 Single Beds",
  "2 Single Beds",
  "3 Single Beds",
  "4 Single Beds",
  "King Bed and Sofa Bed",
  "Queen Bed and Sofa Bed",
  "Single Bed and Sofa Bed",
  "2 King Beds",
  "2 Queen Beds",
  "Input No of Bed Manually",
];

export { facilityOptions, roomViewOptions, roomTypeOptions, beddingOptions };
